// extracted by mini-css-extract-plugin
export default {"main":"Fbm_main__nAuCd"};